// extracted by mini-css-extract-plugin
export default {"root":"card_root__NIaLl","container":"card_container__LNNeF","padding":"card_padding__UOIRf","header":"card_header__WZk-v","body":"card_body__FcLc7"};